export const SELECT_PROPOSAL = 'SELECT_PROPOSAL';
export const CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';
export const ADD_PROPOSAL_TO_COMPARISON = 'ADD_PROPOSAL_TO_COMPARISON';
export const REMOVE_PROPOSAL_FROM_COMPARISON =
  'REMOVE_PROPOSAL_FROM_COMPARISON';
export const CLEAR_COMPARED_PROPOSALS = 'CLEAR_COMPARED_PROPOSALS';
